import classNames from 'classnames';
import React from 'react';
import styles from './RootLayout.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  /** Flex, column direction (remember to flex the children!) */
  flexColumns?: boolean;
  offsetNavbar?: boolean;
  autoOverflow?: boolean;
}

const RootLayout: React.FC<Props> = ({
  children,
  offsetNavbar = true,
  className,
  flexColumns = true,
  autoOverflow,
  ...rest
}) => {
  const containerClass = classNames(
    styles.rootContainer,
    {
      [styles.flexColumns]: flexColumns,
      [styles.offsetNavbar]: offsetNavbar,
      [styles.autoOverflow]: autoOverflow,
    },
    className
  );
  return (
    <div {...rest} className={containerClass}>
      {children}
    </div>
  );
};

export default RootLayout;
